<template>
  <div>
    <v-dialog v-if="about" v-model="about" :width="aboutWidth" :key="aboutKey" class="dialog">
        <v-card >
          <v-card-text class="pa-0 px-7 pt-5 pb-5">
            <v-row>
              <v-col class="pa-0 ma-0 text-center mb-4">
                <v-list-item-subtitle class="version-api">{{$t('about.itemVersion')}} </v-list-item-subtitle>
              </v-col>
            </v-row>
            <v-row v-for="api in aboutText" :key="api.name" class="py-6 ma-0" style="height:24px" >
              <v-col cols="12" sm="6" class="pa-0 ma-0 text-start api-title">
               {{api.application}}: 
              </v-col>
              <v-col cols="12" sm="6" class="pa-0 ma-0 text-start">
                {{api.version}} - {{new Date(api.date).toLocaleString()}}
              </v-col>
            </v-row>
            <v-row class="mt-10" align="center" justify="center">
              <v-col class="text-center text-uppercase" v-if="$config.VUE_APP_CLIENT_BASED_CONFIG&&$config.VUE_APP_CLIENT_BASED_CONFIG.guide!==undefined"> 
                <a :href="$config.VUE_APP_CLIENT_BASED_CONFIG.guide" class="links" target="_blank"> 
                  Guía de uso
                </a>
              </v-col>
              <v-col class="text-left text-center text-uppercase">
                <a href="https://drive.google.com/file/d/16EKrwg5Y7Q_S6kWXHQBn7SN5huICmkKV/view?usp=sharing" class="links" target="_blank"> 
                  Instalador Cliente UltraIp
                </a>
              </v-col>
            </v-row>
            <!--
            <v-row class="pt-2 ma-0">
              <v-col class="pa-0 ma-0 text-center">
                <a :ref="$config.VUE_APP_ULTRAIP_ADDRESS">{{$config.VUE_APP_ULTRAIP_ADDRESS}}</a>
              </v-col>
            </v-row>
            -->
          </v-card-text>
        </v-card>
      </v-dialog>
    <v-app-bar
      absolute
      app
      flat
      dense
      clipped-left
      height="100px"
      style="position:fixed"
      color="#fff"
    >
      <router-link to="/"><v-img src="@/assets/imgs/logo.png" max-width="190px" class="mt-3 logo" ></v-img></router-link>
      <v-app-bar-nav-icon @click="drawer = true" class="hidden-lg-and-up"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>
      <p class="px-5 text-capitalize username">{{username}}</p>
      <v-menu
        left
        bottom
        offset-y
        max-width="auto"
        min-width="auto"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="ma-0 account-icon" max-width="38px" max-height="38px">
            <v-img :src="user4Line" max-width="22px" style="z-index:999"></v-img>
          </v-btn>
        </template>
        <v-list width="auto">
          <v-list-item-title class="pl-4 py-2">
            <span class="item-menu">{{username}}</span>
          </v-list-item-title>
          <v-divider/>
          <v-list-item
            v-for="(item,index) in accountOptions"
            :key="index"
            @click.native="clickOption(item)" style="cursor:pointer"
            
          >
             <span class="item-menu logout">{{item}}</span>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn text rounded @click="triggerAbout" class="help-btn"><v-img src="@/assets/imgs/help.png" width="40px" class="help-icon"></v-img></v-btn>
    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
        height="240px"
        style="position:fixed"
      >
        <v-list
          nav
          dense
        >
        <v-list-item-title @click="drawer = false" class="text-right mr-4" style="cursor:pointer">x</v-list-item-title>
          <v-list-item-group
            v-for="item in items"
            :key="item.title"
            link
          >
            <v-list-item>
              <v-list-item-title @click.stop="goTo(item.path)" class="item">{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
  </div>
</template>
<script>
  import user4Line from "@/assets/imgs/user-4-line.svg"
  export default {
    name: 'CoreToolbar',
    data: () => ({
      drawer: false,
      user4Line,
      about:false,
      aboutText: [],
      aboutKey:0
    }),
    computed: {
      username:{
        get(){
          return this.$store.getters.getUsername
        }
      },
      accountOptions: {
        get(){
          return [this.$t('logoff')]
        }
      },
      items:{
        get(){
          var options = [
            { title: this.$t('projects'), icon: 'mdi-folder-outline', path: '/' },
            //{ title: 'Registro de actividad', icon: 'mdi-history', path: '' },
          ]
          if(this.$store.getters.getRole !== "downloader"){
            options.push({
              title: this.$t('myRecord'),  icon: '', path:'/history', class:'v-list-item__title ma-0 black--text font-weight-light'
            })
            options.push({
              title: this.$t('activity'),  icon: '', path:'/history/projects', class:'v-list-item__title ma-0 black--text font-weight-light '
            })
          }
          if(this.$store.getters.getRole === "admin"){
            var opt= { title: this.$t('users'), icon: 'mdi-account-outline', path: '/users' }
            options.splice(1,0,opt)
          }
           if(this.$store.getters.getRole === "admin"){
            options.push({ 
              title: this.$t('organisms'), icon: '', path: '/organism', class:'v-list-item__title ma-0 black--text font-weight-light' 
           })
           }
            if(this.$store.getters.getRole === "legal_auditor"){
            options.push({ 
              title: this.$t('statistics'), icon: '', path: '/statistics', class:'v-list-item__title ma-0 black--text font-weight-light' 
           })
          }
          return options
        }
      },
      version: {
        get() {
          const version = require('../../../version.json')
          return version.version
        }
      },
      aboutWidth:{
        get(){
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return "100%"
            case 'sm': return "80%"
            case 'md': return "50%"
            default: return "35%"
            
          }
        }
      }
    },
    watch: {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      clickOption(item){
        if(item===this.$t('logoff'))
          this.$store.dispatch('signOut')
      },
      goTo(path){
        this.$router.push(path, e=>{console.log(e)})
      },
      async triggerAbout(){
        await this.$extractions.about().then(response=>{
          this.aboutText = response.data
          this.about = true
          this.aboutKey ++
        })
      }
    }
  }
</script>
<style>
   
  
  .item{
    font-family: 'Roboto', 'sans-serif';
  }
  .help-btn::before{
    background-color: #244f99!important;
  }
  .help-btn{
    width: 10px;
  }
  .dialog{
    font-family: 'Roboto', 'sans-serif';
  }
  .links{
    font-weight: bold;
    font-size: 12px;
  }
  .links:hover{
    color: #65656d;
  }
  .version-api{
    font-size: 16px;
    font-weight: 500;
    color: #131415;
  }
  .api-title{
    font-size: 14px;
    color: #131415;
    font-weight: bold;
  }
  .links{
    color: #91919c;
    text-decoration: none;
  } 
  .account-icon{
    background-color: #a9c7f5;
  }
  .username{
    font-size: 18px;
    font-weight: bold;
    font-family: 'Roboto', 'sans-serif';
    padding-top: 16px!important;
  }
  .logout:hover{
    color: #5f98ed!important;
  }
  .help-btn{
      min-width: 66px!important;
    }
  @media (max-width: 700px) {
    .nav-size{
      font-size: 10px!important;
      min-width: 70px;
    }
  }
  @media (max-width: 600px) {
    .logo{
      max-width: 150px!important;
    }
    .username{
      font-size: 16px;
      padding-top: 18px!important;
    }
    .account-icon{
      height: 28px!important;
      width: 28px!important;
    }
    .help-icon{
      height: 28px!important;
      width: 28px!important;
    }
    .item-menu{
      font-size: 12px!important;
    }
  }
  @media (max-width: 500px) {
    .nav-size{
      font-size: 8px!important;
      min-width: 60px;
    }
  }
  @media (max-width: 400px) {
    .logo{
      max-width: 100px!important;
    }
    .username{
      font-size: 14px;
    }
    .account-icon{
      height: 23px!important;
      width: 23px!important;
    }
    .help-icon{
      height: 23px!important;
      width: 23px!important;
    }
    .help-btn{
      min-width: 23px!important;
    }
  }

 

</style>